import { defineStore } from "pinia";
import type { Breadcrumb } from "@/composables/useBreadcrumbs";

type NavigationTrailSource = "category" | "search" | null;

export const useNavigationTrailStore = defineStore("navigationTrail", {
  state: () => ({
    trail: [] as Breadcrumb[],
    source: null as NavigationTrailSource,
    useTrailForNextProduct: false,
  }),
  actions: {
    setTrail(trail: Breadcrumb[], source: NavigationTrailSource = "category") {
      this.trail = trail;
      this.source = source;
    },
    markCategoryListingNavigation() {
      this.useTrailForNextProduct = true;
    },
    markSearchNavigation() {
      this.trail = [];
      this.source = "search";
      this.useTrailForNextProduct = false;
    },
    shouldUseTrailForProduct() {
      const useTrail = this.useTrailForNextProduct;
      this.useTrailForNextProduct = false;
      return useTrail;
    },
    clearTrail() {
      this.trail = [];
      this.source = null;
      this.useTrailForNextProduct = false;
    },
  },
});

